module.exports = __webpack_public_path__ + "img/gp_head.2cbab0ca.webp";